import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Actions,
  BrandHeaderRow,
  BrandLogo,
  Button,
  Card,
  Header,
  HeaderIconButton,
  HeaderText,
  HomeIcon,
  Message,
  Page,
  Shell,
  Subtitle,
  Title
} from '../components/PageTheme';

const HeaderActions = styled(Actions)`
  align-self: flex-start;
  margin-left: auto;
`;

const PaymentSetup = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <Shell>
        <Header>
          <HeaderText>
            <BrandHeaderRow>
              <BrandLogo />
              <HeaderActions>
                <HeaderIconButton type="button" aria-label="Home" onClick={() => navigate('/dashboard')}>
                  <HomeIcon aria-hidden="true" />
                </HeaderIconButton>
              </HeaderActions>
            </BrandHeaderRow>
            <Title>Payment.</Title>
            <Subtitle>Money pledges are accountability-only for this launch.</Subtitle>
          </HeaderText>
        </Header>
        <Card>
          <Message>
            Money amounts are treated as accountability copy only right now.
          </Message>
          <Actions>
            <Button type="button" onClick={() => navigate('/dashboard')}>Back to dashboard</Button>
          </Actions>
        </Card>
      </Shell>
    </Page>
  );
};

export default PaymentSetup;
